import React, { Component } from 'react';
import '../../App.css';
import Header from '../common/header';
import Competences from './Competences';
import Realisations from './Realisations';
import About from './About';
import Contact from './Contact';

class MainView extends Component {
    state = { 
        titles : ['A PROPOS DE MOI','REALISATIONS','COMPETENCES', 'CONTACT'],
        renderCurrent : 0,
     };

    onLogoClick = () => {
        this.setState({renderCurrent : 2});
    }

    onChangeVieW = (el) => {
        switch (el.toUpperCase()){
            case 'COMPETENCES': 
                 this.setState({renderCurrent : 0});
                 break;
            case 'REALISATIONS':
                this.setState({renderCurrent : 1});
                 break;
            case 'A PROPOS DE MOI':
                 this.setState({renderCurrent : 2});
                 break;
            case 'CONTACT':
                this.setState({renderCurrent : 3});
                break;
            default: 
                this.setState({renderCurrent : 2});
                break;
        }
       
    }

    renderingView = () => {
        let {renderCurrent} = this.state;

        switch(renderCurrent){
            case 0 : 
                return (<Competences competences={["JavaScript", "HTML", "CSS", "React", "React Native", "TypeScript", 
                "Twitter Bootstrap", "Material", "API", "Expo", "Native Base", "Photoshop",
                 "Sass", "Webpack"]} />);
                
            case 1 : 
                return (<Realisations  projects={["TravelToGetherApp", "WeatherApp", "WalletApp", "ImpotsApp", "LawyerWebApp"]} />);
               
            case 2 : 
                return (<About/>);
               
            case 3 : 
                return (<Contact/>);
                
            default: 
                return (<About/>);
                
        }
    }

    render() {
        return (
            <div className="site_container">
                <div className="screen_margin-left"></div>
                <div className="screen_center">
                    <div className="site_section-header">
                        <Header titles={this.state.titles} onChangeVieW = {this.onChangeVieW} onLogoClick={this.onLogoClick}/>
                    </div>
                    <div className="site_section-content">
                        {this.renderingView()}
                    </div>
                </div>
                <div className="screen_margin-right"></div>   
            </div>
        );
    }
}

export default MainView;


// WEBPACK FOOTER //
// ./src/components/containers/MainView.js